module.exports = __webpack_public_path__ + "img/manufacturing-1.3aa94f87.png";